import { format } from 'date-fns';

import toggleTableColumns from './toggleTableColumns';

const defaultColumns = [
    { value : 'status_label', label : 'Status', component: 'address-status' },
    { value : 'group', label : 'Grupp' },
    { value : 'latest_email_notification', label : 'Senaste utskick' },
];

const allColumns = [
    ...defaultColumns,
    { value : 'active_sales_period', label : 'Aktiv säljomgång' },
    { value : 'latest_interaction', label : 'Senaste kundinteraktion', component: 'latest-address-interaction' },
    { value : 'municipality', label : 'Kommun' },
    { value : 'customer', label : 'Kundnamn' },
    { value : 'address_type_label', label : 'Fastighetstyp' },
    { value : 'apartment_floor', label : 'Övrig adressuppgift' },
];

const columnValuesMapping = (address, column) => {
    switch (column.value) {
        case 'group':
            return address.group ? address.group.name : '-';
        case 'latest_email_notification':
            if (! address.customer || ! address.customer.latest_email_notification) {
                return '-';
            }

            const notification = address.customer.latest_email_notification;

            return `${notification.subject} (${format(notification.created_at, 'YYYY-MM-DD')})`;
        case 'active_sales_period':
            return address.active_sales_periods && address.active_sales_periods.length > 0 ? 'Ja' : 'Nej';
        case 'latest_interaction':
            return address.latest_interaction ? address.latest_interaction.label : '-';
        case 'customer':
            return address.customer ? valueWithFallback(address.customer.name) : '-';
        default:
            return valueWithFallback(address[column.value]);
    }
};

const valueWithFallback = (value) => value ? value : '-';

export default {
    namespaced: true,
    state: {
        ...toggleTableColumns.state,
        storeName: 'salesProjectAddressesTable',
        selectedColumns: [],
        defaultColumns,
        allColumns,
    },
    getters: {
        ...toggleTableColumns.getters,
        mappedColumnValue: () => (model, column) => columnValuesMapping(model, column),
    },
    actions: toggleTableColumns.actions,
    mutations: toggleTableColumns.mutations,
};
